        <template>
  <b-card>
    <b-row
          >
                                    <b-col
                                                                                      sm="6"
                                        >
                            <select-input
  id="structCP"
  name="structCP"
    :value.sync="xparam1"
        :options="[]"
      :getOptionLabel="option =&gt; option.text"
      :reduce="val =&gt; val.value"
            label="Период"
  api="https://api.prohealthfactor.ru/api/v1/json/lkb/service/data/list/structCP"
  />            </b-col>
                                        <b-col
                                                                                      sm="6"
                                        >
              <div
                                class="d-flex justify-content-end pt-2"
                              >
                                  <div
                                        >
                                            <download-button
  href="https://api.prohealthfactor.ru/api/v1/json/lkb/buyer/lp/export/BuyerWeek"
      :xparam1="xparam1"
                  label="Excel"
  format="xlsx"
    variant="outline-primary"
        classes="ml-50"
  />                  </div>
                                  <div
                                        >
                                            <refresh-button
  label="Обновить"
  :refresh.sync="refresh"
    variant="outline-primary"
        classes="ml-50"
  />                  </div>
                              </div>
            </b-col>
                                        <b-col
                                                                                      sm="12"
                                        >
                            <basic-table
  :columns="[{&quot;key&quot;:&quot;id_num&quot;,&quot;sortable&quot;:true,&quot;label&quot;:&quot;\u2116\u043f\u043f&quot;,&quot;type&quot;:&quot;text&quot;,&quot;thClass&quot;:&quot;text-center&quot;,&quot;tdClass&quot;:&quot;text-right&quot;},{&quot;key&quot;:&quot;FIO&quot;,&quot;sortable&quot;:true,&quot;label&quot;:&quot;\u0424\u0418\u041e&quot;,&quot;type&quot;:&quot;text&quot;,&quot;thClass&quot;:&quot;text-center&quot;},{&quot;key&quot;:&quot;Owner&quot;,&quot;sortable&quot;:true,&quot;label&quot;:&quot;\u0421\u043f\u043e\u043d\u0441\u043e\u0440&quot;,&quot;type&quot;:&quot;text&quot;,&quot;thClass&quot;:&quot;text-center&quot;},{&quot;key&quot;:&quot;Sponsor&quot;,&quot;sortable&quot;:true,&quot;label&quot;:&quot;\u041f\u043e\u0434 \u043a\u0435\u043c \u0441\u0442\u043e\u0438\u0442&quot;,&quot;type&quot;:&quot;text&quot;,&quot;thClass&quot;:&quot;text-center&quot;},{&quot;key&quot;:&quot;town_name&quot;,&quot;sortable&quot;:true,&quot;label&quot;:&quot;\u0413\u043e\u0440\u043e\u0434&quot;,&quot;type&quot;:&quot;text&quot;,&quot;thClass&quot;:&quot;text-center&quot;},{&quot;key&quot;:&quot;Status&quot;,&quot;sortable&quot;:true,&quot;label&quot;:&quot;\u0421\u0442\u0430\u0442\u0443\u0441&quot;,&quot;type&quot;:&quot;text&quot;},{&quot;key&quot;:&quot;struct&quot;,&quot;sortable&quot;:true,&quot;label&quot;:&quot;\u0412\u0435\u0442\u043a\u0430&quot;,&quot;type&quot;:&quot;text&quot;,&quot;thClass&quot;:&quot;text-center&quot;,&quot;tdClass&quot;:&quot;text-center&quot;},{&quot;key&quot;:&quot;actions&quot;,&quot;label&quot;:&quot;&quot;,&quot;sortable&quot;:false,&quot;actions&quot;:[{&quot;label&quot;:&quot;\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044c \u0432 \u0441\u0435\u0442\u044c \u043a\u043e\u043d\u0442\u0440\u0430\u043a\u0442 \u2116 {id}&quot;,&quot;name&quot;:&quot;setBranch&quot;,&quot;icon&quot;:&quot;CheckIcon&quot;,&quot;api&quot;:&quot;https:\/\/api.prohealthfactor.ru\/api\/v1\/json\/lkb\/buyer\/lp\/set\/branch&quot;,&quot;alert&quot;:false}]}]"
          :refresh="refresh"
        :xparam1="xparam1"
                                api="https://api.prohealthfactor.ru/api/v1/json/lkb/buyer/lp/grid/allbuyer"
          />            </b-col>
                            </b-row>
  </b-card>
</template>
<script>
/* eslint-disable */
// prettier-ignore
import {
  BCard,
  BRow,
  BCol,
} from 'bootstrap-vue'

import { ref } from '@vue/composition-api'

                                      import SelectInput from '@core/components/input/select-input/SelectInput.vue'
                                                                            import DownloadButton from '@core/components/button/DownloadButton.vue'
                                                                        import RefreshButton from '@core/components/button/RefreshButton.vue'
                                                                          import BasicTable from '@core/components/table/basic-table/BasicTable.vue'
                            
export default {
  components: {
    BCard,
    BRow,
    BCol,

                                                          SelectInput,
                                                                                              DownloadButton,
                                                                            RefreshButton,
                                                                                            BasicTable,
                                          },
  setup() {
                const xparam1 = ref('0')
            const refresh = ref(false)
          
          return {
            xparam1,
            refresh,
            }
      },
}
</script>
    